import React from 'react';
import ReactDOM from 'react-dom';
import GA4React from 'ga-4-react';
import App from './App.troy';
import reportWebVitals from './reportWebVitals';
import { isDomainNL } from './constants/browser';
import './index.troy.scss';
import './assets/fonts/fonts.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import 'react-intl-tel-input/dist/main.css';

let ga4react;

if (!window.Cypress) {
  ga4react = new GA4React(
    process.env[`REACT_APP_GA4_ID_${isDomainNL() ? 'NL' : 'DE'}`],
    {},
    [],
    5000,
    { nonce: ['troy-script-is-async','troy-second-script'] }   // static nonces for now
  );
}

(async _ => {
  try {
    if (!window.Cypress) {
      await ga4react.initialize();
    }
  } catch (e) {
    console.error(e);
  } finally {
    ReactDOM.render(
      // <React.StrictMode>
      <App />,
      // </React.StrictMode>,
      document.getElementById('root')
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
